import PageSpinner from '@components/PageSpinner';
import { Stack, Text, type StackProps } from '@mantine/core';
import { type FC, type ReactNode } from 'react';

interface Props extends StackProps {
    icon?: React.ReactNode;
    title?: string;
    description?: string | ReactNode;
    action?: ReactNode;
    loading?: boolean;
}

const SuboptimalState: FC<Props> = ({
    icon,
    title,
    description,
    action,
    loading,
    ...rest
}) => {
    return (
        <Stack
            spacing="sm"
            {...rest}
            sx={{
                height: '100%',
                width: '100%',
                alignContent: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                alignItems: 'center',
                ...rest?.sx,
            }}
        >
            {loading && <PageSpinner />}
            {icon && !loading && icon}
            {title && (
                <Text color="gray.7" fz={18} fw={600}>
                    {title}
                </Text>
            )}
            {description && typeof description === 'string' ? (
                <Text maw={400}>{description}</Text>
            ) : (
                description
            )}
            {action && action}
        </Stack>
    );
};

export default SuboptimalState;
